import React from "react";
import Layout from "../Layout";
import Form from "./form";
import useApi from "Hooks/Admin/useApi";
import useAuth from "Hooks/Admin/useAuth";
import useError from "Hooks/useError";
import { message } from "constants/message";
import { withRouter } from "react-router";

function CollectionThemeEdit(props) {
  const { params } = props.match;
  const collectionThemeId = parseInt(params.id, 10);

  const { request } = useApi();
  const auth = useAuth();
  const stateError = useError();
  const messages = message();
  const [collectionTheme, setCollectionTheme] = React.useState(null);

  React.useEffect(() => {
    document.title = "Buzz Finder Admin - 絞り込みテーマ更新";
  }, []);

  React.useEffect(() => {
    if (!auth.state.token) {
      return;
    }
    fetchCollectionTheme();
  }, [auth.state.token]);

  const fetchCollectionTheme = () => {
    request({
      method: "GET",
      url: `admin/keywords/${collectionThemeId}`,
    }).then((result) => {
      const data = result.data.data;
      setCollectionTheme({
        themeName: data.name,
        summary: data.desc,
        keywords: data.words ? data.words.join("\n") : "",
      });
    });
  };

  const handleSubmit = (collectionTheme) => {
    let data = {
      name: collectionTheme.themeName,
      desc: collectionTheme.summary,
      word_type: "filter",
      words: collectionTheme.keywords
        .split("\n")
        .map((line) => line.trim())
        .filter((line) => line.length > 0),
    };

    request({
      method: "PUT",
      url: `admin/keywords/${collectionThemeId}`,
      data: data,
    })
      .then(() => {
        stateError.initialize();
        props.history.push("/admin/collectionthemes?success=edit");
      })
      .catch(() => {
        stateError.dispatch({
          type: "set",
          payload: {
            isError: true,
            errorMsg: messages.validation.common,
          },
        });
      });
  };

  return (
    <Layout
      content={
        <Form
          submit={handleSubmit}
          collectionTheme={collectionTheme}
          isEdit={true}
        />
      }
    />
  );
}

export default withRouter(CollectionThemeEdit);
